import {
	type FetchMinimalWithdrawalAmountByCurrencyTypeParams,
	type FetchUserWalletParams,
	type FetchWalletMeBalanceData,
	type FetchWalletMeBalanceParams,
	walletApi
} from '@capsicum/common';

export async function fetchUserWallet(params: FetchUserWalletParams) {
	return (await walletApi).fetchUserWallet(params).then(res => res.data);
}

export type FetchWalletMeBalanceType = FetchWalletMeBalanceData['data'];
export async function fetchWalletMeBalance(params: FetchWalletMeBalanceParams): Promise<FetchWalletMeBalanceType> {
	return (await walletApi).fetchWalletMeBalance(params).then(res => res.data);
}

export async function fetchMinimalWithdrawalAmountByCurrencyType(
	params: FetchMinimalWithdrawalAmountByCurrencyTypeParams
) {
	return (await walletApi).fetchMinimalWithdrawalAmountByCurrencyType(params).then(res => res.data);
}
